export const RECEIVED = 'Received';
export const SUBMITTED = 'Submitted';
export const LOCATING = 'Locating';
export const LOCATED = 'Located';
export const ASSIGNED = 'Assigned';
export const COMPLETE = 'Complete';
export const DELAY = 'Delay';
export const CANCELLED = 'Cancelled';
